import * as React from 'react';
export const FullMetalUiThemeContext = /*#__PURE__*/React.createContext(null);
export const useFullMetalUiTheme = () => {
  const FMUTheme = React.useContext(FullMetalUiThemeContext);

  if (FMUTheme === null) {
    throw new Error('No FMU theme available on context');
  }

  return FMUTheme;
};
export const useFullMetalUiColors = () => useFullMetalUiTheme().tokens.colors;
export const useFullMetalUiSpaces = () => {
  const theme = useFullMetalUiTheme();
  return token => {
    const value = theme.tokens.space[token].value * theme.tokens.grid.value;
    return `${value}${theme.tokens.space[token].unit}`;
  };
};
//# sourceMappingURL=FullMetalUiThemeContext.js.map